// removed by extract-text-webpack-plugin
module.exports = {"wrapper-input-number":"magazines_1cfNW","wrapper-input-number__append":"magazines_19JtX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/InputNumber/styles.scss
// module id = 1218
// module chunks = 1